import React from 'react'
import PropTypes from 'prop-types'
import LoginButton from './LoginButton'
import NavLinkGroup from './NavLinkGroup'
import Accessibility from '../icons/Accessibility'

import '../../sass/mainv3.scss'

function TopBar({ theme, linkGroups, myAccount, login }) {
  const topbar = true
  return (
    <ul className="top-bar-ul show-desktop">
      <NavLinkGroup linkGroups={linkGroups} topbar={topbar} />
      <LoginButton theme={theme} myAccount={myAccount} loginButton={login} topbar={topbar} />
      <Accessibility />
    </ul>
  )
}

TopBar.propTypes = {
  theme: PropTypes.object.isRequired,
  linkGroups: PropTypes.object.isRequired,
  myAccount: PropTypes.array.isRequired,
  login: PropTypes.object.isRequired
}

export default TopBar
